module.exports = __webpack_public_path__ + "img/dk.5301cfaf.svg";